export const enum AppRoutes {
  Home = '/',
  ActionTemplateEdit = '/settings/templates/action/:actionId/edit',
  Admin = '/admin',
  AdminConsultingCompanies = '/admin/consulting-companies',
  AdminEnterprises = '/admin/enterprises',
  AdminUsers = '/admin/users',
  AdminCms = '/admin/cms',
  AdminUser = '/admin/users/:id',
  ConsultationRawMaterialities = '/consultation/raw-materialities/:consultationId',
  IndicatorsCollect = '/indicators-collect',
  IndicatorsCollectEditDimensionItem = '/indicators-collect/dimension/:dimensionSlug/:dimensionItemSlug',
  IndicatorsCollectEditIndicator = '/indicators-collect/:indicatorSlugOrId',
  IndicatorsCollectEditOrganizationUnitIndicator = '/indicators-collect/:indicatorSlugOrId/:organizationUnitId',
  Iro = '/iro',
  IroList = '/iro/list',
  IroMaterialityThresholds = '/iro/thresholds',
  IroSettings = '/iro/settings',
  IroRating = '/iro/:pillarId/:stakeId',
  MaturityEvaluations = '/maturity',
  MaturityEvaluationAssign = '/maturity/:surveyId/assign',
  MaturityEvaluationImport = '/maturity/import',
  MaturityEvaluationItem = '/maturity/:surveyId',
  MaturityEvaluationItemTab = '/maturity/:surveyId/:tab',
  Project = '/project',
  ProjectCompany = '/project/company',
  SymfonyProjectEnterprise = '/project/enterprise-symfony',
  ProjectNotebook = '/project/notebook',
  ProjectRoles = '/project/roles',
  ProjectSettings = '/project/settings',
  ProjectUsers = '/project/users',
  Publication = '/publications',
  PublicationDoubleMaterialityMatrixIro = '/publications/double-materiality-matrix/iro',
  PublicationDoubleMaterialityMatrixStakeholder = '/publications/double-materiality-matrix/stakeholder',
  PublicationPrioritizationMatrix = '/publications/prioritization-matrix',
  PublicationMaterialityMatrix = '/publications/materiality-matrix',
  PublicationMaturity = '/publications/maturity',
  Reports = '/reports',
  ReportsDimensions = '/reports/dimensions',
  ReportDisclosureRequirement = '/reports/:reportId/disclosure-requirements/:disclosureRequirementSlug',
  ReportDisclosureRequirementCollectIndicators = '/reports/:reportId/disclosure-requirements/:disclosureRequirementSlug/collect-indicators',
  ReportDisclosureRequirementGapAnalysis = '/reports/:reportId/disclosure-requirements/:disclosureRequirementSlug/gap-analysis',
  ReportStandardRequirements = '/reports/:reportId/standardRequirements',
  ReportHome = '/reports/:reportId',
  ReportCarbonHubImport = '/reports/:reportId/carbon-hub/import',
  ReportCheckList = '/reports/:reportId/checklist',
  ReportIndicators = '/reports/:reportId/indicators',
  ReportSynthesis = '/reports/:reportId/synthesis',
  Register = '/register/:companyId/:token',
  RegisterConsultingCompany = '/register/consultingCompany/:companyId/:token',
  Resources = '/resources',
  Roadmap = '/roadmap',
  RoadmapAction = '/roadmap/action/:actionId',
  RoadmapActionEdit = '/roadmap/action/:actionId/edit',
  StakeholderMapping = '/stakeholder-mapping',
  Settings = '/settings',
  SettingsCoach = '/settings/coaches',
  SettingsCompany = '/settings/company',
  SettingsTemplates = '/settings/templates',
  Stakes = '/stakes',
  Survey = '/survey',
  SurveyItem = '/survey/:surveyId',
  SurveyResults = '/survey/results',
  SurveyTab = '/survey/:surveyId/:tab',
}
